module.exports = __webpack_public_path__ + "img/Feature.bf8df860.jpg";